import React from 'react';
import { connect } from 'react-redux';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import { policyOperations } from 'insured-ui-state-mgmt/dist/ducks/policy';
import PropTypes from 'prop-types';
import Loading from './Loading';

import NotificationSystem from 'react-notification-system';
import { AddNotification, NotificStyle } from '../assets/constants/notification';
import { PolicySummaryPage } from '../assets/constants/constants';
import { Input, Button, Link } from '../assets/constants/styles';

class RegistrationScreen3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    $('#registrationModal')
      .modal('show')
      .on('hidden.bs.modal', function() {
        window.location.href = PolicySummaryPage;
      });
    this.notificationSystem = React.createRef();
  }
  componentDidMount() {
    // check user loggedin instead of email
    // if (!this.props.account.email) {
    // this.props.setAccountInfo({email: "alumula@alumula.com"});
    // this.props.transition.router.stateService.go('registrationScreen1', {}, { location: false });
    //}
  }
  componentDidUpdate(prevProps) {
    if (!Object.is(this.props.response, prevProps.response)) {
      this.setState({ loading: false });
      if (this.props.response.code && this.props.response.code !== 0) {
        this._addNotification('error', 'Api Error', this.props.response.message);
      } else if (
        this.props.response.error &&
        this.props.response.error.code &&
        this.props.response.error.code === 1
      ) {
        this._addNotification('error', 'Api Error', this.props.response.error.message);
      } else {
        this._addNotification('success', 'Api Success', 'Policy added successfully');
        window.location.href = PolicySummaryPage;
      }
    }
  }
  _next() {
    const { policyNumber, pinNumber } = this.props.account;
    if (!policyNumber || !pinNumber) {
      this._addNotification('warning', 'Input Error', 'Please Enter policy number and pin number');
      return;
    }
    this.setState({ loading: true });
    this.props.savePolicyDetails(pinNumber, policyNumber, '');
  }
  _onTextChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.props.setAccountInfo({ [name]: value });
  }

  _addNotification = (notificLevel, messageTitle, messageBody) => {
    AddNotification(this.notificationSystem.current, notificLevel, messageTitle, messageBody);
  };

  render() {
    return (
      <div>
        <NotificationSystem ref={this.notificationSystem} style={NotificStyle} />
        {this.state.loading && <Loading show={this.state.loading} />}
        {!this.state.loading && (
          <div style={{ textAlign: 'center', fontSize: '16px' }}>
            <br />
            <div>Welcome to West Bend</div>
            <br />
            <div>To begin, please enter your pin number and policy number.</div>
            <br />
            <div className="form-group">
              <Input
                className="form-control"
                name="policyNumber"
                onChange={event => this._onTextChange(event)}
                placeholder="Policy number"
                type="text"
              />
            </div>
            <div className="form-group">
              <Input
                className="form-control"
                name="pinNumber"
                onChange={event => this._onTextChange(event)}
                placeholder="Pin number"
                type="text"
              />
            </div>
            <Button className="btn" onClick={() => this._next()}>
              Next
            </Button>
            <br />
            <Link href="javascript:;">I don't have a policy with West Bend</Link>
            <br />
            <br />
            <Link href="javascript:;">I can't find my policy number</Link>
            <br />
            <br />
            <Link href="javascript:;">I can't find my pin number</Link>
            <br />
            <br />
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  account: state.account.registrationDetails,
  response: state.policy.response
});
const mapDispatchToProps = {
  setAccountInfo: accountOperations.registerUser_1,
  savePolicyDetails: policyOperations.associatePolicy
};
RegistrationScreen3.propTypes = {
  account: PropTypes.object,
  response: PropTypes.object,
  savePolicyDetails: PropTypes.func,
  setAccountInfo: PropTypes.func,
  transition: {
    router: {
      stateService: {
        go: PropTypes.func
      }
    }
  }
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationScreen3);
